<ion-content class="ion-padding">

  <div class="max-page-width">
    <ion-grid lines="none" mode="ios" class="title-with-back-button-text">
      <ion-row align-items-center>
        <ion-col size="4">
          <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
            <ion-icon class="bp-arrow-left"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col size="4" class="team-status">
          <ion-label class="ion-text-center ion-text-wrap">
            {{ 'performanceCycles.performanceCycles' | translate }}
          </ion-label>
        </ion-col>
        <ion-col size="4" class="cycle-configs">
          <ng-container *ngIf="cycleConfigurationAvailable">
            <div fill="clear" mode="ios" color="primary" class="btn-edit-cycle edit-cycle" (click)="goToEditCycleConfig()">
              {{ 'generic.edit' | translate }}
            </div>
          </ng-container>
          <ion-button class="btn-select-cycle" mode="ios" color="primary" fill="outline" (click)="selectCycle()">
            <ion-label>
              {{ selectedCycle ? selectedCycle?.name : ('generic.selectCycle' | translate) }}
            </ion-label>
          </ion-button>
          <ng-container *ngIf="cycleConfigurationAvailable">
            <ion-button class="btn-new-cycle" mode="ios" color="secondary" (click)="goToAddCycleConfig()">
              {{ 'performanceCycles.newCycleBtn' | translate }}
            </ion-button>
          </ng-container>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- <div class="ion-margin-bottom">
          <ion-segment segment-custom large mode="ios" [(ngModel)]="cycles">
            <ion-segment-button mode="ios" value="openCycles">
              <ion-label>
                {{ 'performanceCycles.openCycles' | translate }}
              </ion-label>
            </ion-segment-button>
            <ion-segment-button mode="ios" value="closedCycles">
              <ion-label>
                {{ 'performanceCycles.closedCycles' | translate }}
              </ion-label>
            </ion-segment-button>
          </ion-segment>
        </div> -->

    <div [ngSwitch]="cycles">
      <div *ngSwitchCase="'openCycles'" class="open-cycles">
        <!-- <ion-item color="darkyellow" lines="none" class="collaborators-without-cycle">
                  <ion-icon slot="start" class="bp-warning"></ion-icon>
                  <ion-label text-wrap>
                    <ion-text>10</ion-text> {{ 'performanceCycles.employeesWithoutCycle' | translate }}
                  </ion-label>
                  <ion-button mode="ios" slot="end" color="darkyellow">
                    <span hidden-mobile>
                      {{ 'performanceCycles.viewEmployees' | translate }}
                    </span> 
                    <ion-icon class="bp-arrow-right"></ion-icon>
                  </ion-button>
                </ion-item> -->

        <app-cycle *ngFor="let cycle of performanceCycles" [performanceCycle]="cycle"
          [cycleConfigurationAvailable]="cycleConfigurationAvailable" [isLoadingSteps]="isLoadingSteps"
          (selectYear)="selectYear($event.cycleId)">
        </app-cycle>

      </div>
      <div *ngSwitchCase="'closedCycles'" class="close-cycles "></div>
    </div>
  </div>
</ion-content>